import * as fromDatatype from '../datatype-library/index';

export interface bl_msg_msgbox_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mb_type: fromDatatype.VarcharDatatypeInterface;
  owner_guid: fromDatatype.GuidDataFieldInterface;
  mb_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_msg_msgbox_RowClass implements bl_msg_msgbox_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mb_type: fromDatatype.VarcharDatatypeInterface;
  owner_guid: fromDatatype.GuidDataFieldInterface;
  mb_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

